__webpack_require__.p = "/Babel-Shopping/";